import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useMemo,
} from "react";

import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import "./subcourseStyle.css";

import Loader from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";

import ApproverActionPanel from "./ApproverActionPanel";
import TaskStatus from "../../enums/TaskStatus";
const groupByTitle = (items) => {
  return items.reduce((acc, curr) => {
    if (!acc[curr.Title]) acc[curr.Title] = [];
    acc[curr.Title].push(curr);
    return acc;
  }, {});
};

const SubCourses = forwardRef(
  (
    {
      segmentId,
      classTypeId,
      CourseId,
      examTypeId,
      getSelectedSubTopic,
      nextQuestion,
      previousQuestion,
      questionData,
      questionSelectedTopicsData,
      updateQuestionInfo,
      onLabelsUpdate,
      setLoader,
      loader,
      allSegmentData,
      onShowLogs,
      resetSelectionKey
    },
    ref
  ) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const [processSelection, setProcessSelection] = useState(null);


    const handleNavigate = async (direction) => {
      if (loader) return;

      if (processSelection === TaskStatus.Approve) {
        await updateQuestionInfo(undefined, undefined, TaskStatus.Approve);
      }

      if (processSelection === TaskStatus.NotSure) {
        await updateQuestionInfo(undefined, undefined, TaskStatus.NotSure);
      }

      // ❌ Reject → handled in modal, do not update here

      direction === "next" ? nextQuestion() : previousQuestion();
    };

    return (
      <div className="subcourse-container">
        {/* Loader container */}
        {loader && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader size={100} />
          </div>
        )}
        {!loader && processSelection&&(
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <button
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => handleNavigate("next")}
              className="nav-btn"
            >
              Sonraki <ArrowForwardIcon />
            </button>
          </div>
        )}
        <ApproverActionPanel
          key={questionData.BookSectionCropId}
          onApprove={({ processStatus }) => {
            setProcessSelection(processStatus);
          }}
          onNotSure={({ processStatus }) => {
            setProcessSelection(processStatus);
          }}
          onReject={({ processStatus }) => {
            setProcessSelection(processStatus);
            onShowLogs(); // opens modal
          }}
          resetSelectionKey={resetSelectionKey}
        />
      </div>
    );
  }
);

export default SubCourses;
